<template>
  <v-card
    class="city-report mx-auto pa-2 overflow-visible"
    outlined
  >
    <v-list-item>
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Báo cáo doanh thu và đơn hàng theo vùng miền
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-row>
      <v-col cols="12" md="4">
        <v-list-item>
          <v-list-item-title class="headline mb-2 text-center">
            Doanh thu
          </v-list-item-title>
        </v-list-item>

        <div
          v-if="chartDataTurnOver.series && chartDataTurnOver.series.length"
        >
          <chartist 
            ratio="ct-major-second"
            type="Pie"
            :data="chartDataTurnOver"
            :options="chartOptions"
          />
        </div>
        
        <common-no-result
          v-if="chartDataTurnOver.series && !chartDataTurnOver.series.length"
        />
      </v-col>
      <v-col cols="12" md="2" class="mt-10">
        <div
          v-if="chartDataTurnOver.series && chartDataTurnOver.series.length"
        >
          <CityReportRevenueModal
            :chartDataTurnOver="chartDataTurnOver"
            :otherTurnOver="otherTurnOver"
          />
        </div>
      </v-col>

      <!-- Quantities -->
      <v-col cols="12" md="4">
        <v-list-item>
          <v-list-item-title class="headline mb-2 text-center">
            Số đơn hàng
          </v-list-item-title>
        </v-list-item>
        <div
          v-if="chartDataQty.series && chartDataQty.series.length"
        >
          <chartist 
            ratio="ct-major-second"
            type="Pie"
            :data="chartDataQty"
            :options="chartOptions"
          />
        </div>
        
        <common-no-result
          v-if="chartDataQty.series && !chartDataQty.series.length"
        />
      </v-col>
      <v-col cols="12" md="2" class="mt-10">
        <div
            v-if="chartDataQty.series && chartDataQty.series.length"
          >
          <CityReportQuantitiesModal
            :chartDataQty="chartDataQty"
            :otherQuantities="otherQuantities"
          />
        </div>
      </v-col>
    </v-row>

  </v-card>
</template>

<script>

import { formatPrice } from '@/helpers/utils'
import { colorChart } from '@/helpers/constants'
import * as moment from 'moment'
import * as ChartistTooltips from 'chartist-plugin-tooltips';

import CityReportRevenueModal from "./CityReportRevenueModal";
import CityReportQuantitiesModal from "./CityReportQuantitiesModal";
import RepositoryFactory from "@/repositories/RepositoryFactory";
const ReportRepository = RepositoryFactory.get('report');

export default {
  components: {CityReportRevenueModal, CityReportQuantitiesModal},
  props: {
    filterForm: {
      default: () => ({})
    },
  },
  data () {
    return {
      chartDataTurnOver: {},
      chartDataQty: {},
      chartOptions: {
        height: 300,
        showLabel: false,
        labelInterpolationFnc: function(value) {
          if (parseInt(value.slice(0, -1)) < 10) {
            return ''
          } else {
            return value
          }
        },
        plugins: [this.$chartist.plugins.tooltip(
          {
            currency: ' ',
            tooltipFnc: function(meta, value) {
              let data = meta.split(',')
              return data[0] + ': ' + value + '<br>Tỷ lệ: ' + data[1]
            }
          }
        )],
      },
      chartPopupTurnOver: {},
      chartPopupQty: {},
      color: colorChart,
      title: ['Doanh thu nhóm số cũ', 'Doanh thu nhóm số mới'],
      popupQuantities: false,
      popupTurnOver: false,
      otherTurnOver: [],
      otherQuantities: [],
      headersTurnOver: [
        { text: 'Tên địa phương', value: 'text' },
        { text: 'Tỷ lệ', value: 'percentage' },
        { text: 'Doanh thu', value: 'revenue' },
      ],
      headersQuantites: [
        { text: 'Tên địa phương', value: 'text' },
        { text: 'Tỷ lệ', value: 'percentage' },
        { text: 'Số lượng', value: 'countItems' },
      ],
    }
  },
  created() {
    Bus.$on('city-report', () => {
      this.fetchData()
    })
    this.fetchData()
  },
  beforeDestroy() {
    Bus.$off('city-report')
  },
  methods: {
    async fetchData() {
      const loader = this.$loading.show()
      const params = {
        startDateTime: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
        endDateTime: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      };
      const result = await ReportRepository.fetchCity(params)
      loader.hide()

      if (result.success) {
        const response = _.get(result, 'data', {})

        // TurnOver
        const chartDataTurnOver = {
          series: [],
          labels: [],
          cities: [],
          color: colorChart
        }
        Object.values(response.turnOvers).map(e => {
          chartDataTurnOver.series.push({
            meta: e.provinceName + ',' + e.percentage + '%',
            value: parseFloat(e.revenue)
          })
          chartDataTurnOver.labels.push(e.percentage + '%')
          chartDataTurnOver.cities.push({key: e.provinceId, value: e.provinceName})
        })
        this.chartDataTurnOver = chartDataTurnOver
        console.log(this.chartDataTurnOver)

        // TurnOver Other
        const otherTurnOver = []
        Object.values(response.otherTurnOvers).map(e => {
          otherTurnOver.push({
            text: e.provinceName,
            revenue: formatPrice(parseFloat(e.revenue)),
            percentage: e.percentage + '%',
          })
        })
        this.otherTurnOver = otherTurnOver

        // Quantities
        const chartDataQty = {
          series: [],
          labels: [],
          cities: [],
          color: colorChart
        }
        Object.values(response.quantities).map(e => {
          chartDataQty.series.push({
            meta: e.provinceName + ',' + e.percentage + '%',
            value: parseFloat(e.countItems)
          })
          chartDataQty.labels.push(e.percentage + '%')
          chartDataQty.cities.push({key: e.provinceId, value: e.provinceName})
        })
        this.chartDataQty = chartDataQty

        // Quantities Other
        const otherQuantities = []
        Object.values(response.otherQuantities).map(e => {
          otherQuantities.push({
            text: e.provinceName,
            percentage: parseFloat(e.percentage) + '%',
            countItems: formatPrice(parseFloat(e.countItems)),
          })
        })
        this.otherQuantities = otherQuantities
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.popup {
  position: relative;
  &.show .popupDetails {
    visibility: visible;
  }
  .popupDetails {
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(-50%, -100%);
    padding: 10px 20px;
    background: green;
  }
}
</style>